import React from 'react'
import Container from 'js/pages/LandingPages/components/Container'
import { FeatureImage, FeatureImageType } from 'js/components/FeatureImage'
import { PerformanceLandingPage_performanceLandingPage_sections_contentBlocks_MealPlansBlockRecord } from '../types/PerformanceLandingPage'
import { SharedSectionProps } from './types'

type Props =
  PerformanceLandingPage_performanceLandingPage_sections_contentBlocks_MealPlansBlockRecord &
    SharedSectionProps

const MealPlans = ({
  label,
  title,
  subtitle,
  description,
  mealPlans,
}: Props) => {
  return (
    <section className="pt-56 lg:pt-[115px]">
      <Container>
        <span className="text-14 font-demibold uppercase leading-19 tracking-1.12 lg:text-17 lg:leading-23 lg:tracking-1.36">
          {label}
        </span>
        <h2 className="quincy max-w-[620px] pb-32 text-32 leading-37 lg:pb-24 lg:text-48 lg:leading-52">
          {title}
        </h2>
        <p className="lg:quincy max-w-[730px] pb-32 text-17 font-semiregular leading-21 lg:pb-56 lg:text-20 lg:font-regular lg:leading-23 ">
          {subtitle}
        </p>
        <p className="max-w-[410px] pb-16 text-14 font-demibold uppercase tracking-1.12 lg:pb-24 lg:text-17 lg:leading-23 lg:tracking-1.36">
          {description}
        </p>
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-x-[40px]">
          {mealPlans.map((item, index) => (
            <div key={index} className="relative">
              {item.link ? (
                <a
                  href={item.link}
                  className="absolute inset-0"
                  aria-label={item.text as string}
                />
              ) : null}
              <FeatureImage
                image={item.image?.responsiveImage as FeatureImageType}
                className="w-full"
              />
              <div className="pt-4 text-12 font-semiregular leading-16 lg:pt-2 lg:text-14 lg:leading-19">
                {item.text}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default MealPlans
